import {memo} from 'react';
import {Controller, useFormContext} from 'react-hook-form';

import DatePicker from 'react-datepicker';
import {addDays} from 'date-fns';
import {useTranslation} from 'react-i18next';

import {LanguageService, useService} from '@innowise-group/core';
import {preventDefaultOnChange} from '../../utilities';
import {DatePickerInput} from '../date-picker-input';
import {BookingMeetingRoomFormFields, BookMeetingDatePicker} from '../booking-meeting-room-form';
import {CalendarIcon} from './book-meeting-date.styles';

const BookMeetingDate = () => {
  const {control, watch, resetField} = useFormContext();
  const {t} = useTranslation();
  const {getAppLanguage} = useService(LanguageService);

  return (
    <Controller
      name={BookingMeetingRoomFormFields.Date}
      control={control}
      defaultValue={new Date()}
      render={({field: {onChange, value}}) => (
        <BookMeetingDatePicker type="date">
          <DatePicker
            selected={watch(BookingMeetingRoomFormFields.Date) ? watch(BookingMeetingRoomFormFields.Date) : new Date()}
            minDate={new Date()}
            dateFormat="dd.MM.yyyy"
            maxDate={addDays(new Date(), 7)}
            locale={getAppLanguage()}
            popperPlacement="bottom-start"
            popperClassName="popper"
            onChangeRaw={preventDefaultOnChange}
            customInput={
              <DatePickerInput
                value={value}
                name={BookingMeetingRoomFormFields.Date}
                label={t('modals.bookMeetingRoom.date')}
              />
            }
            onChange={(value: Date) => {
              onChange(value);
              resetField(BookingMeetingRoomFormFields.StartTime);
              resetField(BookingMeetingRoomFormFields.EndTime);
            }}
          />
          <CalendarIcon type="u_calender" />
        </BookMeetingDatePicker>
      )}
    />
  );
};

export default memo(BookMeetingDate);
